import { makeAutoObservable } from "mobx";
import { ModalSize, ModalPopup } from "src/models/ModalPopup";


export default class CommonStore {

  alertMsg: any = {isOpen: false, isSuccess: false, isReload: false, title: "", message: ""};
  modalPopup: ModalPopup = {open: false, size: ModalSize.TINY, body: null}

  isSidebarShow = false;
  isMobileAccess = false; 

  constructor() {
    makeAutoObservable(this);
  }

  setAlertMsg(value: any) {
    this.alertMsg = value;
  }

  setAlertMsgOpen = (value: boolean) => {
    this.alertMsg.isOpen = value;
  }
  
  setSidebarShow = (value: boolean) => {
    this.isSidebarShow = value; 
  }

  setMobileAccess = (value: boolean) => {
    this.isMobileAccess = value;
  }
}